import React from 'react';
import ChartDatasetSettings from '../../settings_sidebar/ChartDatasetSettings.jsx';
import { DEFAULT_ADDITIONAL_SETTINGS } from '../../settings_sidebar/chart/ChartSettings.jsx';

function CumulativeLineDatasetWidgetSettings({ widgetId }) {
    return (
        <ChartDatasetSettings
            widgetId={widgetId}
            chart_settings_props = {{
                interval_options: ["day", "month", "quarter", "year"],
                additional_settings: [...DEFAULT_ADDITIONAL_SETTINGS, "start_date", "end_date", "interval"],
                dataset_mode_options: ["single", "grouped"]
            }}
            dataset_settings_props= {{
                dataset_params: { cumulative: true },
                dataset_settings: ["dataset_id", "name_item", "number_unit", "number_precision"]
            }}
        />
    )
}

export default CumulativeLineDatasetWidgetSettings;
